// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#profile-item .user[data-v-454dc55f]{display:flex;align-items:center;min-width:365px}#profile-item .user span[data-v-454dc55f]{display:inline-block;font-weight:500;margin-left:5px}#profile-item .btn[data-v-454dc55f]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
